import { Award, Star } from "lucide-react";

export const isTopRated = (r) => Boolean(r && r.count >= 3 && r.average >= 4.5);

export const TopRatedBadge = ({ testId }) => (
  <span data-testid={testId} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#1C1917] text-white text-[11px] font-semibold uppercase tracking-wider">
    <Award size={12} className="text-[#F2B544]" /> Top rated
  </span>
);

export const Stars = ({ value, size = 16, onPick, testId }) => (
  <div className="flex items-center gap-0.5" aria-label={`${value || 0} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((n) => {
      const icon = <Star size={size} className={n <= Math.round(value || 0) ? "fill-[#E06D44] text-[#E06D44]" : "text-stone-300"} />;
      return onPick ? (
        <button key={n} type="button" data-testid={testId?.(n)} onClick={() => onPick(n)} aria-label={`${n} star${n === 1 ? "" : "s"}`} className="p-1 hover:scale-110 transition-transform">{icon}</button>
      ) : <span key={n}>{icon}</span>;
    })}
  </div>
);
